/*
  gb-search-overlay.js (v2.1) — golfballs.at Such-Overlay

  Passt 1:1 zum Markup in gb-mega-header.liquid (v5.10) — die Liquid-Datei
  muss dafür NICHT geändert werden. Einfach assets/gb-search-overlay.js
  durch diese Datei ersetzen.

  FIX IN V2.1 — "pro" fand etwas, "prot" nicht mehr.
  Wahrscheinlichste Ursache: ein zweites, älteres Such-Script (z. B. in
  gb-mega-header.js) hört ebenfalls auf das Suchfeld, sucht ab 4 Zeichen
  selbst und schreibt danach "Keine Ergebnisse" über unsere Treffer.
  Deshalb jetzt:
   a) Tipp-Ereignisse im Suchfeld werden abgefangen, BEVOR ein anderes
      Script sie bekommt -> es gibt nur noch eine Suchlogik.
   b) Wächter: ändert trotzdem fremder Code die Ergebnisliste, wird unser
      Ergebnis sofort wiederhergestellt.
   c) Produkt-Index mit drei Ausweich-Adressen (/de-at/products.json,
      /products.json, /collections/all/products.json); ein leerer Index
      gilt als Fehler und wird nicht gecacht.
   d) ?searchdebug=1 zeigt jetzt direkt IM Overlay, was passiert
      (Treffer je Quelle, Index-Größe, fremde Eingriffe) — Screenshot genügt.

  SUCHLOGIK (seit v2.0)
  - Treffer ab 2 Zeichen, auch mitten im Wort: "pro", "prot", "tee", "vx".
  - Jedes Suchwort muss irgendwo vorkommen: Titel, Marke, Typ, Tags,
    Variante oder SKU. Umlaute/ß normalisiert, Leerzeichen egal
    ("pro tee" <-> "ProTee").
  - Quelle A: Shopify Predictive Search (Marktpreise, Relevanz).
  - Quelle B: eigener Produkt-Index (echte "enthält"-Suche).
  - Enter -> volle Suchergebnisseite; Link "Alle Ergebnisse anzeigen".
*/
(function () {
  'use strict';
  if (window.__gbSearchOverlayV21) return;
  window.__gbSearchOverlayV21 = true;

  var CFG = {
    minChars: 2,
    debounceMs: 140,
    maxResults: 12,
    recentKey: 'gb-recently-viewed',
    recentMax: 8,
    indexKey: 'gb-search-index-v3',
    indexTtlMs: 30 * 60 * 1000,
    indexPageSize: 250,
    indexMaxPages: 12,
    maxRepairsPerQuery: 25
  };
  var DEBUG = /[?&]searchdebug/.test(window.location.search);
  var DBG = { index: 'noch nicht geladen', indexSrc: '', shopify: '-', local: '-', repairs: 0, blocked: 0, q: '' };
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[gb-search]'].concat([].slice.call(arguments))); }

  /* ---------------- Helfer ---------------- */

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function isDe() { return /^de/i.test(document.documentElement.lang || 'de'); }

  function norm(s) {
    s = String(s == null ? '' : s).toLowerCase().replace(/ß/g, 'ss');
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function currency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  }
  function currencyRate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return isFinite(r) && r > 0 ? r : 1;
  }

  function money(amount, cur) {
    var n = Number(amount);
    if (amount === '' || amount == null || !isFinite(n)) return '';
    var loc = document.documentElement.lang || 'de-AT';
    if (loc.toLowerCase() === 'de') loc = 'de-AT';
    try {
      return new Intl.NumberFormat(loc, { style: 'currency', currency: cur || currency() }).format(n);
    } catch (e) {
      return n.toFixed(2).replace('.', ',') + ' ' + (cur || currency());
    }
  }

  function sizedImg(url, w) {
    if (!url) return '';
    url = String(url);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 360);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function injectCss() {
    if (document.getElementById('gb-search-v2-css')) return;
    var st = document.createElement('style');
    st.id = 'gb-search-v2-css';
    st.textContent =
      '.gb-search-overlay__body.is-loading [data-gb-search-results-grid]{opacity:.55;transition:opacity .15s ease}' +
      '.gb-search-overlay__all{display:inline-flex;align-items:center;margin-top:22px;font-size:13px;font-weight:700;' +
      'color:var(--gb-green,#006500);text-decoration:none}' +
      '.gb-search-overlay__all:hover{text-decoration:underline}' +
      '.gb-search-card__price.is-soldout{color:var(--gb-ink,#14231a);opacity:.5}' +
      '.gb-search-debug{flex-shrink:0;padding:8px 20px;border-top:1px dashed rgb(0 0 0 / .2);' +
      'font:11px/1.5 ui-monospace,Menlo,monospace;color:#7a4b00;background:#fff8e6;white-space:pre-wrap}';
    document.head.appendChild(st);
  }

  /* ---------------- Quelle A: Shopify Predictive Search ---------------- */

  function predictiveUrl(q, withFields) {
    var p = [
      'q=' + encodeURIComponent(q),
      'resources[type]=product',
      'resources[limit]=10',
      'resources[limit_scope]=each',
      'resources[options][prefix]=last',
      'resources[options][unavailable_products]=last'
    ];
    if (withFields) p.push('resources[options][fields]=title,product_type,vendor,tag,variants.title,variants.sku');
    return root() + 'search/suggest.json?' + p.join('&');
  }

  function mapPredictive(data) {
    var list = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    return list.map(function (p) {
      var img = (p.featured_image && (p.featured_image.url || p.featured_image.src)) || p.image || '';
      return {
        handle: p.handle,
        title: p.title,
        url: p.url || (root() + 'products/' + p.handle),
        image: img,
        price: p.price,
        priceCur: currency(),
        available: p.available !== false
      };
    });
  }

  function predictive(q, signal) {
    function go(withFields) {
      return fetch(predictiveUrl(q, withFields), { signal: signal, headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) return withFields ? go(false) : null;
          return r.json();
        });
    }
    return go(true)
      .then(function (d) { return d && d.resources ? mapPredictive(d) : []; })
      .catch(function (e) { if (e && e.name === 'AbortError') throw e; log('predictive Fehler', e); return []; });
  }

  /* ---------------- Quelle B: eigener Produkt-Index ---------------- */

  var indexPromise = null;

  function readCachedIndex() {
    try {
      var raw = sessionStorage.getItem(CFG.indexKey);
      if (!raw) return null;
      var c = JSON.parse(raw);
      if (!c || c.root !== root() || Date.now() - c.ts > CFG.indexTtlMs || !Array.isArray(c.items) || !c.items.length) return null;
      return c;
    } catch (e) { return null; }
  }

  function writeCachedIndex(items, src) {
    if (!items.length) return;
    try { sessionStorage.setItem(CFG.indexKey, JSON.stringify({ ts: Date.now(), root: root(), src: src, items: items })); } catch (e) {}
  }

  function compactProduct(p) {
    var tags = Array.isArray(p.tags) ? p.tags.join(' ') : (p.tags || '');
    var variants = p.variants || [];
    var skus = variants.map(function (v) { return v.sku || ''; }).join(' ');
    var vtitles = variants.map(function (v) { return v.title && v.title !== 'Default Title' ? v.title : ''; }).join(' ');
    var min = null, avail = false;
    variants.forEach(function (v) {
      var n = parseFloat(v.price);
      if (isFinite(n) && (min === null || n < min)) min = n;
      if (v.available) avail = true;
    });
    var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    return {
      h: p.handle,
      t: p.title,
      i: typeof img === 'string' ? img : '',
      p: min,
      a: avail,
      n: norm(p.title),
      x: norm([p.vendor, p.product_type, tags, vtitles, skus].join(' '))
    };
  }

  function fetchIndexFrom(url) {
    var items = [];
    function page(n) {
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      return fetch(url + sep + 'limit=' + CFG.indexPageSize + '&page=' + n, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) {
          var prods = (d && d.products) || [];
          prods.forEach(function (p) { if (p && p.handle) items.push(compactProduct(p)); });
          if (prods.length === CFG.indexPageSize && n < CFG.indexMaxPages) return page(n + 1);
          if (!items.length) throw new Error('leer');
          return items;
        });
    }
    return page(1);
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;
    var cached = readCachedIndex();
    if (cached) {
      DBG.index = cached.items.length + ' Produkte (Cache)';
      DBG.indexSrc = cached.src || '';
      indexPromise = Promise.resolve(cached.items);
      return indexPromise;
    }
    var candidates = [root() + 'products.json', '/products.json', '/collections/all/products.json'];
    candidates = candidates.filter(function (u, i) { return candidates.indexOf(u) === i; });
    var errors = [];
    DBG.index = 'lädt …';

    function tryNext(i) {
      if (i >= candidates.length) return Promise.reject(new Error(errors.join(' | ')));
      return fetchIndexFrom(candidates[i])
        .then(function (items) { return { items: items, src: candidates[i] }; })
        .catch(function (e) { errors.push(candidates[i] + ': ' + (e && e.message)); return tryNext(i + 1); });
    }

    indexPromise = tryNext(0)
      .then(function (res) {
        DBG.index = res.items.length + ' Produkte';
        DBG.indexSrc = res.src;
        log('Index geladen:', res.items.length, 'von', res.src);
        writeCachedIndex(res.items, res.src);
        return res.items;
      })
      .catch(function (e) {
        DBG.index = 'FEHLER – ' + (e && e.message);
        log('Index nicht verfügbar', e);
        indexPromise = null; // beim nächsten Tippen erneut versuchen
        return [];
      });
    return indexPromise;
  }

  function localMatch(items, q) {
    var nq = norm(q);
    if (!nq) return [];
    var tokens = nq.split(' ');
    var qCompact = nq.replace(/ /g, '');
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var hay = it.n + ' ' + it.x;
      var hayC = hay.replace(/ /g, '');
      var all = true;
      for (var k = 0; k < tokens.length; k++) {
        if (hay.indexOf(tokens[k]) === -1 && hayC.indexOf(tokens[k]) === -1) { all = false; break; }
      }
      if (!all && hayC.indexOf(qCompact) === -1) continue;

      var tC = it.n.replace(/ /g, '');
      var score = 0;
      if (it.n.indexOf(nq) === 0 || tC.indexOf(qCompact) === 0) score += 100;
      else if ((' ' + it.n).indexOf(' ' + tokens[0]) > -1) score += 60;
      else if (tC.indexOf(qCompact) > -1) score += 40;
      else score += 10;
      if (it.a) score += 5;
      score -= Math.min(it.n.length, 80) / 40;
      out.push({ s: score, it: it });
    }
    out.sort(function (a, b) { return b.s - a.s; });
    var rate = currencyRate();
    return out.map(function (o) {
      var it = o.it;
      return {
        handle: it.h,
        title: it.t,
        url: root() + 'products/' + it.h,
        image: it.i,
        price: rate === 1 ? it.p : '',
        priceCur: currency(),
        available: it.a
      };
    });
  }

  function merge(a, b) {
    var seen = {}, out = [];
    a.concat(b).forEach(function (p) {
      if (!p || !p.handle || seen[p.handle]) return;
      seen[p.handle] = true;
      out.push(p);
    });
    return out.slice(0, CFG.maxResults);
  }

  /* ---------------- Zuletzt angesehen ---------------- */

  function getRecent() {
    try { var l = JSON.parse(localStorage.getItem(CFG.recentKey) || '[]'); return Array.isArray(l) ? l : []; }
    catch (e) { return []; }
  }
  function setRecent(list) {
    try { localStorage.setItem(CFG.recentKey, JSON.stringify(list.slice(0, CFG.recentMax))); } catch (e) {}
  }

  function trackCurrentProduct() {
    var h = window.gbCurrentProductHandle;
    if (!h) return;
    fetch(root() + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.handle) return;
        var item = {
          handle: p.handle,
          title: p.title,
          url: root() + 'products/' + p.handle,
          image: p.featured_image || '',
          price: typeof p.price === 'number' ? p.price / 100 : '',
          priceCur: currency(),
          available: p.available !== false
        };
        setRecent([item].concat(getRecent().filter(function (x) { return x && x.handle !== item.handle; })));
      })
      .catch(function () {});
  }

  /* ---------------- Overlay ---------------- */

  function Overlay(ov) {
    this.ov = ov;
    this.input = ov.querySelector('[data-gb-search-input]');
    this.body = ov.querySelector('[data-gb-search-body]');
    this.recentSec = ov.querySelector('[data-gb-search-recent]');
    this.recentGrid = ov.querySelector('[data-gb-search-recent-grid]');
    this.resSec = ov.querySelector('[data-gb-search-results]');
    this.resGrid = ov.querySelector('[data-gb-search-results-grid]');
    this.empty = ov.querySelector('[data-gb-search-empty]');
    this.seq = 0;
    this.ctrl = null;
    this.timer = null;
    this.lastFocus = null;
    this.state = { mode: 'idle', list: [], q: '' };
    this.repairs = 0;
    this.bind();
    this.guard();
    if (DEBUG) {
      this.dbg = el('div', 'gb-search-debug', '');
      var panel = ov.querySelector('.gb-search-overlay__panel') || ov;
      panel.appendChild(this.dbg);
      this.updateDebug();
    }
  }

  Overlay.prototype.updateDebug = function () {
    if (!this.dbg) return;
    this.dbg.textContent =
      'searchdebug v2.1 | Suche: "' + DBG.q + '" | Shopify: ' + DBG.shopify + ' | Index-Treffer: ' + DBG.local +
      '\nIndex: ' + DBG.index + (DBG.indexSrc ? ' (' + DBG.indexSrc + ')' : '') +
      ' | fremde Tipp-Ereignisse abgefangen: ' + DBG.blocked + ' | fremde Eingriffe repariert: ' + DBG.repairs;
  };

  // Tipp-/Tasten-Ereignisse aus dem Suchfeld (kommen über den Capture-Abfang)
  Overlay.prototype.onFieldEvent = function (e) {
    var self = this;
    if (e.type === 'input' || e.type === 'compositionend' || e.type === 'search') {
      clearTimeout(this.timer);
      this.timer = setTimeout(function () { self.search(self.input.value); }, CFG.debounceMs);
    } else if (e.type === 'keydown') {
      if (e.key === 'Enter') {
        var q = this.input.value.trim();
        if (q) { e.preventDefault(); window.location.href = this.fullUrl(q); }
      } else if (e.key === 'Escape') {
        this.close();
      }
    }
  };

  Overlay.prototype.bind = function () {
    var self = this;
    this.ov.addEventListener('click', function (e) {
      if (e.target === self.ov) { self.close(); return; }
      if (e.target.closest('[data-gb-search-close]')) { self.close(); return; }
      if (e.target.closest('[data-gb-search-clear-recent]')) {
        setRecent([]);
        self.showIdle();
      }
    });
  };

  // Wächter: überschreibt fremder Code unsere Anzeige, stellen wir sie wieder her.
  Overlay.prototype.guard = function () {
    if (!window.MutationObserver) return;
    var self = this;
    this.mo = new MutationObserver(function () {
      if (self.ov.hidden) return;
      if (self.repairs >= CFG.maxRepairsPerQuery) return;
      self.repairs++;
      DBG.repairs++;
      log('fremde Änderung erkannt -> wiederhergestellt');
      self.applyState();
    });
    var targets = [this.resGrid, this.recentGrid, this.empty, this.resSec, this.recentSec];
    targets.forEach(function (t) {
      if (t) self.mo.observe(t, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
    });
  };

  Overlay.prototype.quiet = function () {
    if (this.mo) this.mo.takeRecords(); // eigene Änderungen nicht als "fremd" werten
    this.updateDebug();
  };

  Overlay.prototype.fullUrl = function (q) {
    return root() + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
  };

  Overlay.prototype.open = function () {
    if (!this.ov.hidden) { if (this.input) this.input.focus(); return; }
    this.lastFocus = document.activeElement;
    this.ov.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var self = this;
    setTimeout(function () { if (self.input) { self.input.focus(); if (self.input.select) self.input.select(); } }, 30);
    loadIndex();
    var q = this.input ? this.input.value : '';
    if (q.trim().length >= CFG.minChars) this.search(q); else this.showIdle();
  };

  Overlay.prototype.close = function () {
    if (this.ov.hidden) return;
    this.ov.hidden = true;
    document.documentElement.style.overflow = '';
    if (this.ctrl) this.ctrl.abort();
    if (this.lastFocus && this.lastFocus.focus) { try { this.lastFocus.focus(); } catch (e) {} }
  };

  Overlay.prototype.card = function (p) {
    var a = el('a', 'gb-search-card');
    a.href = p.url;
    var imgWrap = el('span', 'gb-search-card__img');
    if (p.image) {
      var img = document.createElement('img');
      img.src = sizedImg(p.image, 360);
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      imgWrap.appendChild(img);
    }
    a.appendChild(imgWrap);
    a.appendChild(el('p', 'gb-search-card__title', p.title || ''));
    var priceTxt = money(p.price, p.priceCur);
    if (priceTxt) a.appendChild(el('p', 'gb-search-card__price' + (p.available ? '' : ' is-soldout'), priceTxt));
    return a;
  };

  Overlay.prototype.fill = function (grid, list) {
    if (!grid) return;
    while (grid.firstChild) grid.removeChild(grid.firstChild);
    var self = this;
    list.forEach(function (p) { grid.appendChild(self.card(p)); });
  };

  Overlay.prototype.removeAllLink = function () {
    var old = this.ov.querySelectorAll('.gb-search-overlay__all');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
  };

  Overlay.prototype.applyState = function () {
    var s = this.state;
    this.removeAllLink();
    if (this.body) this.body.classList.remove('is-loading');

    if (s.mode === 'idle') {
      this.fill(this.resGrid, []);
      if (this.resSec) this.resSec.hidden = true;
      if (this.empty) this.empty.hidden = true;
      var cur = window.gbCurrentProductHandle;
      var recent = getRecent().filter(function (x) { return x && x.handle && x.handle !== cur; });
      if (recent.length && this.recentSec) {
        this.fill(this.recentGrid, recent.slice(0, 8));
        this.recentSec.hidden = false;
      } else if (this.recentSec) {
        this.recentSec.hidden = true;
      }
    } else if (s.mode === 'loading') {
      if (this.body) this.body.classList.add('is-loading');
      if (this.empty) this.empty.hidden = true;
    } else if (!s.list.length) {
      if (this.recentSec) this.recentSec.hidden = true;
      this.fill(this.resGrid, []);
      if (this.resSec) this.resSec.hidden = true;
      if (this.empty) this.empty.hidden = false;
    } else {
      if (this.recentSec) this.recentSec.hidden = true;
      if (this.empty) this.empty.hidden = true;
      this.fill(this.resGrid, s.list);
      if (this.resSec) {
        this.resSec.hidden = false;
        var all = el('a', 'gb-search-overlay__all',
          isDe() ? 'Alle Ergebnisse für „' + s.q + '“ anzeigen' : 'Show all results for “' + s.q + '”');
        all.href = this.fullUrl(s.q);
        this.resSec.appendChild(all);
      }
    }
    this.quiet();
  };

  Overlay.prototype.showIdle = function () {
    this.state = { mode: 'idle', list: [], q: '' };
    this.applyState();
  };

  Overlay.prototype.render = function (list, q) {
    this.state = { mode: 'results', list: list, q: q };
    this.applyState();
  };

  Overlay.prototype.search = function (raw) {
    var q = String(raw || '').trim();
    var my = ++this.seq;
    this.repairs = 0;
    DBG.q = q;
    if (this.ctrl) this.ctrl.abort();
    if (q.length < CFG.minChars) { this.showIdle(); return; }

    this.ctrl = window.AbortController ? new AbortController() : null;
    var signal = this.ctrl ? this.ctrl.signal : undefined;
    if (this.state.mode !== 'results') { this.state = { mode: 'loading', list: [], q: q }; this.applyState(); }
    else if (this.body) { this.body.classList.add('is-loading'); this.quiet(); }
    var self = this;

    Promise.all([
      predictive(q, signal),
      loadIndex().then(function (items) { return localMatch(items, q); })
    ]).then(function (res) {
      if (my !== self.seq) return;
      DBG.shopify = res[0].length;
      DBG.local = res[1].length;
      log('„' + q + '“ -> Shopify:', res[0].length, '| Index:', res[1].length);
      self.render(merge(res[0], res[1]), q);
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      if (my !== self.seq) return;
      loadIndex().then(function (items) {
        if (my !== self.seq) return;
        var local = localMatch(items, q);
        DBG.shopify = 'Fehler'; DBG.local = local.length;
        self.render(merge([], local), q);
      });
    });
  };

  /* ---------------- Start ---------------- */

  function overlayOfField(target) {
    var inp = target && target.closest && target.closest('[data-gb-search-input]');
    if (!inp) return null;
    var ov = inp.closest('[data-gb-search-overlay]');
    return ov && ov.__gbSearch ? ov.__gbSearch : null;
  }

  function init() {
    injectCss();
    trackCurrentProduct();

    var overlays = [];
    document.querySelectorAll('[data-gb-search-overlay]').forEach(function (ov) {
      if (ov.__gbSearch) return;
      ov.__gbSearch = new Overlay(ov);
      overlays.push(ov.__gbSearch);
    });
    if (!overlays.length) return;

    // Abfang in der Capture-Phase auf window: läuft VOR allen Listenern, die
    // andere Scripts direkt am Suchfeld oder am document registriert haben.
    // Das Tippen selbst bleibt unberührt (kein preventDefault außer bei Enter).
    ['input', 'keydown', 'keyup', 'keypress', 'change', 'search', 'compositionend'].forEach(function (type) {
      window.addEventListener(type, function (e) {
        var o = overlayOfField(e.target);
        if (!o) return;
        e.stopImmediatePropagation();
        e.stopPropagation();
        if (type === 'input' || type === 'keyup') DBG.blocked++;
        o.onFieldEvent(e);
      }, true);
    });

    function overlayFor(btn) {
      var host = btn.closest('gb-mega-header');
      var ov = host && host.querySelector('[data-gb-search-overlay]');
      return (ov && ov.__gbSearch) || overlays[0];
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-gb-search-open]');
      if (!btn) return;
      e.preventDefault();
      overlayFor(btn).open();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') overlays.forEach(function (o) { o.close(); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();